module.exports = __webpack_public_path__ + "static/media/1.cf5f511e.png";